module.exports = __webpack_public_path__ + "static/media/astro_manufacturing.d0d2e3ff.png";